import { Action, INIT, createReducer, createSelector, on } from '@ngrx/store';
import { ResponseSuccessAuthLogoutAction } from '../actions';
import * as actions from './settings.actions';
import { NotificationPreferencesDto } from '@careapp-group/ng-sdk-v2-new';

export interface State {
  notifications?: NotificationPreferencesDto;
  loading: boolean;
  error?: any;
}

export const INITIAL_STATE = {
  loading: false,
};

export const reducer = createReducer<State>(
  INITIAL_STATE,
  on(actions.RequestNotificationPreferencesAction, (state) => ({ ...state, loading: true })),
  on(actions.RequestUpdateNotificationPreferencesAction, (state) => ({ ...state, loading: true })),

  on(actions.ResponseSuccessNotificationPreferencesAction, (state, action) => ({
    ...state,
    loading: false,
    notifications: action.payload,
  })),
  on(actions.ResponseSuccessUpdateNotificationPreferencesAction, (state, action) => ({
    ...state,
    loading: false,
    notifications: action.payload,
  })),
  on(actions.ResponseFailNotificationPreferencesAction, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  })),
  on(actions.ResponseFailUpdateNotificationPreferencesAction, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))
);

export const getNotificationPreferences = (state: State) => state.notifications;

export const createSelectors = (rootReducer: any) => ({
  /**
   * Gets the notifications preferences
   */
  getNotificationPreferences: createSelector(
    rootReducer,
    (settings: State) => settings.notifications
  ),

  /**
   * Loading observable
   */
  isSettingsLoading: createSelector(rootReducer, (settings: State) => settings.loading),
});
